import { api } from '../../shared/api/client';
import { adaptInvoice } from '../../shared/api/adapters';
import type { ApiInvoice, PaginatedResponse } from '../../shared/types/api';
import type { Invoice } from '../../shared/types/app';

export async function fetchInvoiceByRequest(requestId: string): Promise<Invoice> {
  const res = await api.get<ApiInvoice>(`/api/v1/invoices/request/${requestId}`);
  return adaptInvoice(res);
}

// The current customer's own invoice history — a separate endpoint from findAll (admin-only)
// and findByRequest (per-request), scoped server-side by the caller's own id.
export async function fetchMyInvoices(params: { page?: number; limit?: number } = {}): Promise<PaginatedResponse<Invoice>> {
  const q = new URLSearchParams();
  if (params.page) q.set('page', String(params.page));
  if (params.limit) q.set('limit', String(params.limit));
  const qs = q.toString() ? `?${q.toString()}` : '';
  const res = await api.get<PaginatedResponse<ApiInvoice>>(`/api/v1/invoices/me${qs}`);
  return { ...res, data: res.data.map(adaptInvoice) };
}
